<template>
    <Toaster />
    <div class="form-wrapper">
        <legend class="form-legend">{{ model.translations['donation.Form.MandatoryFieldsExplanation'] }}</legend>
        <form @submit.prevent="onSubmit" class="donate-form">
            <div class="form-section">
                <h2>{{ model.translations["donation"] }}</h2>
                <div class="field-group">
                    <FormField v-slot="{ componentField }" name="donationType" v-if="showDonationTypeSelect">
                        <FormItem>
                            <FormControl>
                                <Select v-bind="componentField">
                                    <FormControl>
                                        <SelectTrigger class="w-full">
                                            <SelectValue
                                                :placeholder="model.translations['donation.Form.ReferenceEventType']" />
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent class="max-h-[400px]">
                                        <SelectGroup>
                                            <SelectLabel>Donations Types</SelectLabel>
                                            <SelectItem v-for="item in model.donationTypes" :value="item.value">
                                                {{ item.text }}
                                            </SelectItem>
                                        </SelectGroup>
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="hospiceId" v-if="showHospiceSelect">
                        <FormItem>
                            <FormControl>
                                <Select v-bind="componentField">
                                    <FormControl>
                                        <SelectTrigger class="w-full">
                                            <SelectValue
                                                :placeholder="model.translations['donation.Form.SelectHospice']" />
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent class="max-h-[400px]">
                                        <SelectGroup>
                                            <SelectLabel>Charities</SelectLabel>
                                            <SelectItem v-for="item in model.hospiceList" :value="item.text">
                                                {{ item.value }}
                                            </SelectItem>
                                        </SelectGroup>
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                </div>
                <div class="field-group">
                    <Select @update:model-value="(val) => form.setFieldValue('amount', val)"
                        v-if="sortedDonationValues.length > 0">
                        <FormControl>
                            <SelectTrigger class="w-full">
                                <SelectValue :placeholder="model.translations['donation.Form.Amount']" />
                            </SelectTrigger>
                        </FormControl>
                        <SelectContent class="max-h-[400px]">
                            <SelectGroup>
                                <SelectLabel>Donation amount</SelectLabel>
                                <SelectItem v-for="item in sortedDonationValues" :value="String(item)">
                                    {{ item }}
                                </SelectItem>
                            </SelectGroup>
                        </SelectContent>
                    </Select>
                    <CurrencyInput name="amount" :options="CURRENCY_OPTIONS" />
                </div>
                <FormField v-slot="{ componentField }" name="message">
                    <FormItem>
                        <FormControl>
                            <Textarea type="text" :placeholder="model.translations['donation.Form.OptionalMessage']"
                                v-bind="componentField" />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
            </div>
            <div class="form-section">
                <h2>{{ model.translations["donation.Form.ContactDetails"] }}</h2>
                <div class="field-group">
                    <FormField v-slot="{ componentField }" name="title">
                        <FormItem>
                            <FormControl>
                                <Select v-bind="componentField">
                                    <FormControl>
                                        <SelectTrigger class="w-full">
                                            <SelectValue
                                                :placeholder="model.translations['generic.PersonalDetails.Title']" />
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent class="max-h-[400px]">
                                        <SelectGroup>
                                            <SelectLabel>Titles</SelectLabel>
                                            <SelectItem v-for="item in model.titles" :value="item.value">
                                                {{ item.text }}
                                            </SelectItem>
                                        </SelectGroup>
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="firstName">
                        <FormItem>
                            <FormControl>
                                <Input type="text"
                                    :placeholder="model.translations['generic.PersonalDetails.FirstName']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="lastName">
                        <FormItem>
                            <FormControl>
                                <Input type="text" :placeholder="model.translations['generic.PersonalDetails.LastName']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                </div>
                <FormField v-slot="{ componentField }" name="phone">
                    <FormItem>
                        <FormControl>
                            <VueTelInput type="number" :inputOptions="{
                                placeholder: model.translations['generic.PersonalDetails.PhoneNumber'],
                            }" v-bind="componentField" defaultCountry="GB" class="input" />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
                <div class="field-group">
                    <FormField v-slot="{ componentField }" name="email">
                        <FormItem>
                            <FormControl>
                                <Input type="text" :placeholder="model.translations['generic.PersonalDetails.Email']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="repeatEmail">
                        <FormItem>
                            <FormControl>
                                <Input type="text"
                                    :placeholder="model.translations['generic.PersonalDetails.EmailConfirmation']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                </div>
            </div>
            <div class="form-section">
                <h2>Address</h2>
                <div class="field-group">
                    <FormField v-slot="{ componentField }" name="addressLine1">
                        <FormItem>
                            <FormControl>
                                <Input type="text" :placeholder="model.translations['generic.Address.AddressLine1']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="addresLine2">
                        <FormItem>
                            <FormControl>
                                <Input type="text" :placeholder="model.translations['generic.Address.AddressLine2']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                </div>
                <div class="field-group">
                    <FormField v-slot="{ componentField }" name="locality">
                        <FormItem>
                            <FormControl>
                                <Input type="text" :placeholder="model.translations['generic.Address.Locality']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="countryId">
                        <FormItem>
                            <FormControl>
                                <Select v-bind="componentField">
                                    <FormControl>
                                        <SelectTrigger class="w-full">
                                            <SelectValue :placeholder="model.translations['generic.Address.Country']" />
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent class="max-h-[400px]">
                                        <SelectGroup>
                                            <SelectLabel>Countries</SelectLabel>
                                            <SelectItem v-for="item in model.countries" :value="item.value">
                                                {{ item.text }}
                                            </SelectItem>
                                        </SelectGroup>
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                    <FormField v-slot="{ componentField }" name="postCode">
                        <FormItem>
                            <FormControl>
                                <Input type="text" :placeholder="model.translations['generic.Address.Postcode']"
                                    v-bind="componentField" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    </FormField>
                </div>
            </div>
            <div class="container-gift-aid" v-if="showGiftAid">
                <h2 class="container-gift-aid--title">{{ model.giftAid.title }}</h2>
                <div class="container-gift-aid--subtitle" v-html="model.giftAid.subtitle"></div>
                <FormField v-slot="{ value, handleChange }" name="giftAid">
                    <FormItem class="checkbox-field">
                        <FormControl>
                            <Checkbox :model-value="value" @update:model-value="handleChange" />
                        </FormControl>
                        <FormMessage />
                        <FormLabel>
                            {{ model.giftAid.consent }}
                        </FormLabel>
                    </FormItem>
                </FormField>
                <div class="container-gift-aid--bottom-text" v-html="model.giftAid.text"></div>
                <div class="container-gift-aid--explanation" v-html="model.giftAid.explanatory"></div>
            </div>
            <div class="form-section">
                <h2>{{ model.keepInTouch.title }}</h2>
                <FormField v-slot="{ value, handleChange }" name="contact.selectedContactCheckbox"
                    v-if="model.keepInTouch.checkboxDescription">
                    <FormItem class="checkbox-field">
                        <FormControl>
                            <Checkbox :model-value="value" @update:model-value="handleChange" />
                        </FormControl>
                        <FormLabel v-html="model.keepInTouch.checkboxDescription" class="form-label-column">
                        </FormLabel>
                        <FormMessage />
                    </FormItem>
                </FormField>
                <FormField v-slot="{ value, handleChange }" name="contact.selectedHospiceContactCheckbox"
                    v-if="model.keepInTouch.hospiceCheckboxDescription">
                    <FormItem class="checkbox-field">
                        <FormControl>
                            <Checkbox :model-value="value" @update:model-value="handleChange" />
                        </FormControl>
                        <FormLabel v-html="model.keepInTouch.hospiceCheckboxDescription" class="form-label-column">
                        </FormLabel>
                        <FormMessage />
                    </FormItem>
                </FormField>
                <h6 class="text-xs mt-2">{{ model.keepInTouch.leadSourceTitle }}</h6>
                <FormField v-slot="{ componentField }" name="contact.leadSource">
                    <FormItem>
                        <FormControl>
                            <Select v-bind="componentField">
                                <FormControl>
                                    <SelectTrigger class="w-full md:w-[400px]">
                                        <SelectValue :placeholder="model.translations['generic.Select']" />
                                    </SelectTrigger>
                                </FormControl>
                                <SelectContent>
                                    <SelectGroup>
                                        <SelectItem v-for="item in model.keepInTouch.leadSources" :value="item.value">
                                            {{ item.text }}
                                        </SelectItem>
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
                <div v-if="model.privacyPolicy" class="form-privacy-policy">
                    <span>{{ model.translations['donation.Form.PrivacyPolicy'] }}</span>
                    <a :href="model.privacyPolicy.url" :target="model.privacyPolicy.target">{{
                        model.privacyPolicy.text }}</a>
                </div>
            </div>
            <div class="form-section">
                <h2>{{ model.translations["registerTree.Form.DonationsPaymentMethodTitle"] }}</h2>
                <FormField v-slot="{ value, handleChange }" name="paymentMethodId">
                    <FormItem>
                        <FormControl>
                            <DonatePaymentMethods :value="value" @change="(e) => handleChange(e.id)"
                                :options="paymentMethods?.paymentMethods"></DonatePaymentMethods>
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
            </div>
            <div class="buttons">
                <Button type="submit">
                    Submit
                </Button>
            </div>
        </form>
    </div>
</template>

<script lang="ts" setup>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import type { IDonateFormProps } from './DonateForm.model';
import { useForm } from "vee-validate"
import { CURRENCY_OPTIONS, DONATION_TYPE_HOSPICE } from "./DonateForm.constant"
import {
    FormControl,
    FormField,
    FormItem,
    FormMessage, FormLabel
} from '@/components/ui/form';
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod';
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { Toaster } from '@/components/ui/sonner'
import { Textarea } from '@/components/ui/textarea'
import { toast } from 'vue-sonner'
import { NAME_FIELD_MAX_LENGTH } from "@/contants/constant";
import { computed, onMounted } from "vue";
import { load, type ReCaptchaInstance } from 'recaptcha-v3';
import type { IDonateRequest } from '@/api/donate';
import { donateForm, getPaymentMethods } from '@/api/donate/donate.api';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectItem, SelectLabel, } from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import DonatePaymentMethods from '../DonatePaymentMethods/DonatePaymentMethods.vue';
import CurrencyInput from '@/components/CurrencyInput/CurrencyInput.vue';


const { model } = defineProps<IDonateFormProps>()
let recaptcha: ReCaptchaInstance;

const { data: paymentMethods } = useQuery({ queryKey: ['paymentMethods'], queryFn: () => getPaymentMethods(model.initializePaymentUrl, { culture, currentPageId }) })

const { mutate: contactFormSubmit } = useMutation({
    mutationFn: (data: IDonateRequest) => donateForm(model.submitFormUrl ?? "", data),
    onSuccess: (data) => {
        window.location.href = data.paymentUrl
    },
    onError: (error) => {
        console.log(model.translations["generic.Error"])
    },
})

onMounted(() => {
    if (model.customer) {
        form.setValues({
            title: model.customer.attention,
            firstName: model.customer.firstName,
            lastName: model.customer.lastName,
            addressLine2: model.customer.address2,
            addressLine1: model.customer.address1,
            locality: model.customer.city,
            postCode: model.customer.postCode,
            countryId: model.customer.countryId,
        })
    }
    if (!model.reCaptcha?.siteKey) {
        toast("Can't initialize captcha", { important: true })
        return;
    }
    load(model.reCaptcha?.siteKey ?? "").then(async (recaptchaInstance) => {
        recaptcha = recaptchaInstance
    })
})

const formSchema = toTypedSchema(z.object({
    amount: z.coerce.number("This field is required"),
    message: z.string().optional(),
    title: z.string("This field is required"),
    donationType: z.string("This field is required"),
    hospiceId: z.number().optional(),
    firstName: z.string().max(NAME_FIELD_MAX_LENGTH),
    lastName: z.string().max(NAME_FIELD_MAX_LENGTH),
    phone: z.string("This field is required"),
    email: z.email({ error: (err) => err.code === "invalid_type" ? "This field is required" : "Invalid email address" }),
    repeatEmail: z.email({ error: (err) => err.code === "invalid_type" ? "This field is required" : "Invalid email address" }),
    addressLine1: z.string("This field is required"),
    addressLine2: z.string().optional(),
    locality: z.string("This field is required"),
    countryId: z.string("This field is required"),
    postCode: z.string("This field is required"),
    giftAid: z.boolean().optional(),
    source: z.string().optional(),
    paymentMethodId: z.string("This field is required"),
    contact: z.object({
        leadSource: z.string("This field is required"),
        selectedContactCheckbox: z.boolean().optional(),
        selectedHospiceContactCheckbox: z.boolean().optional()
    })
}).superRefine((data, ctx) => {
    if (data.email !== data.repeatEmail) {
        ctx.addIssue({
            code: "custom",
            message: "Email addresses do not match.",
            path: ['repeatEmail'],
        })
    }

    if (data.donationType === DONATION_TYPE_HOSPICE && !data.hospiceId) {
        ctx.addIssue({
            code: "custom",
            message: "Charity selection is required.",
            path: ['hospiceId'],
        });
    }
}))

const form = useForm({
    validationSchema: formSchema,
    initialValues: {
        countryId: model.giftAidCountryId,
        source: model.campainSource,
        donationType: model.donationTypes.length === 1 ? model.donationTypes[0].value : undefined,
    }
})

const onSubmit = form.handleSubmit((values) => {
    recaptcha.execute("register").then((token) => {
        contactFormSubmit({
            ...values,
            captchaToken: token,
            culture: culture
        })
    })
})

const showGiftAid = computed(() => form.values.countryId === model.giftAidCountryId)
const showDonationTypeSelect = computed(() => model.donationTypes?.length > 1)
const showHospiceSelect = computed(() => form.values.donationType === DONATION_TYPE_HOSPICE)
const culture = window.__STATE__?.culture ?? 'en-GB'
const currentPageId = window.__STATE__?.currentPageId ?? 0

const sortedDonationValues = computed(() => {
    return model.predefinedDonationValues?.slice().sort((a, b) => a - b) ?? []
})
</script>

<style lang="scss" scoped>
.form-label-column {
    flex-direction: column;
    align-items: flex-start;
}

.form-section {
    display: flex;
    flex-direction: column;
    gap: 10px
}

.form-wrapper {
    display: flex;
    flex-direction: column;
}

.form-legend {
    margin-bottom: 5px;
    font-size: 12px;
    color: var(--muted-foreground);
    right: 0;
    align-self: flex-end;
}

.field-group {
    >div {
        flex: 1
    }

    display: flex;
    gap: 1rem;
    flex-direction: column;
}

@media (min-width: 768px) {
    .field-group {
        flex-direction: row;
    }
}

.donate-form {
    display: flex;
    flex-direction: column;
    gap: 20px
}

.buttons {
    display: flex;
    justify-content: flex-end;
}

.input {
    border-color: var(--input);
    border-radius: calc(var(--radius) - 2px);

    ::placeholder {
        color: var(--muted-foreground)
    }
}

.container-gift-aid {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 24px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.34);

    .container-gift-aid--title {
        font-weight: 700;
        font-size: 24px;
        color: var(--primary);
    }

    .container-gift-aid--subtitle {
        font-size: 1.2rem;
        color: var(--primary)
    }

    .container-gift-aid--bottom-text {
        font-size: 0.8rem;
    }

    .container-gift-aid--explanation {
        font-size: 0.8rem;
        font-style: italic;
    }
}

.checkbox-field {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-privacy-policy {
    display: flex;
    gap: 5px;
    font-size: 12px;
    margin-left: 15px;
}
</style>